import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import { CircularProgress } from "@material-ui/core";
import jsPDF from "jspdf";

const ResumeTemplate5 = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidatId] = React.useState("");
  const [candidate, setCandidate] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [initials, setInitials] = React.useState("");

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatId(candidate?.id);
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId !== "") {
      if (storeCandidate.candidate === null) {
        setIsLoading(true);
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setIsLoading(false);
          if (resp?.firstName && resp?.lastName) {
            const firstNameInitial = resp.firstName.charAt(0);
            const lastNameInitial = resp.lastName.charAt(0);
            setInitials(`${firstNameInitial}/${lastNameInitial}`);
          }
        });
      } else if (storeCandidate.candidate !== null) {
        setIsLoading(true);
        setCandidate(storeCandidate.candidate);
        setIsLoading(false);
        if (
          storeCandidate.candidate?.firstName &&
          storeCandidate.candidate?.lastName
        ) {
          const firstNameInitial = storeCandidate.candidate.firstName.charAt(0);
          const lastNameInitial = storeCandidate.candidate.lastName.charAt(0);
          setInitials(`${firstNameInitial}/${lastNameInitial}`);
        }
      }
    }
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".cv-container"), {
      callback: (doc) => {
        doc.save("resume.pdf");
      },
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du CV en cours...</div>
        </div>
      ) : (
        <div className="cv-container">
          <style>
            {`
                    .cv-container {
                        display: flex;
                        max-width: 960px;
                        background-color: #eaeaea;
                        justify-content: space-between;
                        margin: 20px auto;
                        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
                    }
                    .profile {
                        flex-basis: 35%;
                        background-color: #39383a !important;
                        color: #ababab !important;
                    }
                    .profile-photo {
                        height: 270px;
                        background-size: cover;
                        background-position: top;
                        background-repeat: no-repeat;
                    }
                    .profile-info {
                        padding-left: 30px;
                        padding-right: 30px;
                        padding-top: 50px;
                        padding-bottom: 70px;
                    }
                    .profile-text {
                        font-size: 14px;
                        line-height: 24.19px;
                        margin-bottom: 10px;
                    }
                    .heading {
                        margin: 0;
                        padding-bottom: 16px;
                        text-transform: uppercase;
                        font-weight: 700;
                    }
                    .heading-light {
                        color: #ffffff;
                        border-bottom: 2px #5a5a5a dashed;
                    }
                    .contacts {
                        margin-bottom: 70px;
                    }
                    .contacts-title {
                        color: #fff;
                        margin-bottom: 13px;
                        font-size: 16px;
                        font-weight: 400;
                    }
                    .contacts-text {
                        color: #ababab;
                        text-decoration: none;
                        padding-left: 27px;
                        line-height: 20.97px;
                    }
                    .contacts-item {
                        padding-top: 24px;
                        padding-bottom: 24px;
                        border-bottom: 2px #5a5a5a dashed;
                    }
                    address {
                        font-style: normal;
                    }
                    .fas {
                        margin-right: 7px;
                    }
                    .languages {
                        display: flex;
                        flex-wrap: wrap;
                        padding-top: 40px;
                    }
                    .language {
                        width: 100px;
                        height: 100px;
                        border: 6px solid #5c5c5c;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        margin-bottom: 30px;
                        margin-right: 30px;
                    }
                    .language:nth-child(3) {
                        margin-bottom: 0;
                    }
                    .language-text {
                        text-transform: uppercase;
                        font-size: 11px;
                    }
                    .languages-per {
                        font-size: 15px;
                        font-weight: 600;
                    }
                    .lines {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }
                    .line {
                        display: block;
                        width: 90px;
                        height: 2px;
                        background-color: #5c5c5c;
                        margin-top: 10px;
                        margin-bottom: 10px;
                    }
                    .line:nth-child(2) {
                        width: 100px;
                        margin-left: 20px;
                    }
                    .resume {
                        padding: 25px 30px;
                        flex-basis: 63%;
                        background-color: #fff;
                    }
                    .resume-wrap {
                        padding: 36px 56px;
                        border: 1px solid rgba(168, 168, 168, 0.44);
                        min-height: 100%;
                    }
                    .logo {
                        display: flex;
                        justify-content: center;
                        margin-bottom: 38px;
                    }
                    .logo-img {
                        width: 90px;
                        height: 90px;
                        border: 1px solid #39383a;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .logo-lines {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        margin-left: 17px;
                        margin-right: 17px;
                    }
                    .logo-line {
                        width: 43px;
                        height: 2px;
                        background-color: #39383a;
                        margin-top: 10px;
                        margin-bottom: 10px;
                    }
                    .logo-lines_left .logo-line:nth-child(2) {
                        margin-right: 20px;
                        width: 55px;
                    }
                    .logo-lines_right .logo-line:nth-child(2) {
                        margin-left: 20px;
                        width: 55px;
                    }
                    .about {
                        padding-bottom: 30px;
                        border-bottom: 1px solid #e0e0e0;
                        text-align: center;
                        margin-bottom: 40px;
                    }
                    .name {
                        font-size: 16px;
                        text-transform: uppercase;
                        letter-spacing: 10.75px;
                        margin-bottom: 10px;
                    }
                    .position {
                        display: inline-block;
                        font-size: 9px;
                        text-transform: uppercase;
                        color: #808080;
                        margin-bottom: 30px;
                    }
                    .about-address {
                        font-size: 13px;
                        margin-bottom: 15px;
                        font-family: Roboto;
                    }
                    .about-contacts {
                        font-size: 8px;
                    }
                    .about-contacts__link {
                        text-decoration: none;
                        color: #777777;
                    }
                    .heading_dark {
                        font-size: 16px;
                        font-weight: 400;
                        border-bottom: 1px solid #e0e0e0;
                        margin-bottom: 37px;
                    }
                    .list {
                        list-style: none;
                        padding-left: 0;
                    }
                    .list-item {
                        position: relative;
                        padding-left: 40px;
                        padding-bottom: 30px;
                        margin-bottom: 30px;
                        border-bottom: 2px dashed #ececec;
                    }
                    .list-item:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 3px;
                        width: 9px;
                        height: 9px;
                        border-radius: 50%;
                        background-color: #000;
                    }
                    .list-item__title {
                        font-size: 11px;
                        text-transform: uppercase;
                        margin-bottom: 5px;
                    }
                    .list-item__date {
                        font-size: 10px;
                        text-transform: uppercase;
                    }
                    .list-item__text {
                        font-size: 10px;
                        color: #777;
                    }
                    .list-item_non-border {
                        border: none;
                    }
                    .heading_skills {
                        margin-bottom: 48px;
                    }
                    .skills-list {
                        list-style-type: none;
                        padding-left: 0;
                    }
                    .skills-list__item {
                        margin-bottom: 30px;
                        text-transform: uppercase;
                        font-size: 11px;
                        display: flex;
                        justify-content: space-between;
                    }
                    
                    .level {
                        width: 70%;
                        height: 8px;
                        border: 1px solid #39383a;
                        position: relative;
                    }
                    .level:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 0;
                        height: 100%;
                        background-color: #898989 !important;
                    }
                    .level-80:before {
                        width: 80%;
                    }
                    .level-90:before {
                        width: 90%;
                    }
                    .level-50:before {
                        width: 50%;
                    }
                    .button-container {
                        position: fixed;
                        right: 20px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }

                    .btn {
                        padding: 12px 20px;
                        font-size: 16px;
                        cursor: pointer;
                        border: none;
                        border-radius: 5px;
                        color: #fff;
                        background-color: #333;
                    }

                    .btn-download {
                        background-color: #5cb85c;
                    }

                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        .container {
                            box-shadow: none;
                            margin: 0;
                        }
                        .profile {
                            flex-basis: 35% !important;
                            background-color: #39383a !important;
                            color: #ababab !important;
                        }
                        .profile-photo {
                            background-size: cover;
                            background-position: top;
                            background-repeat: no-repeat;
                        }
                        .resume {
                            background-color: #fff !important;
                        }
                        .list-item:before {
                            background-color: #000 !important;
                        }
                        .button-container, footer {
                            display: none;
                        }
                    }
                `}
          </style>

          <div className="profile">
            <div className="profile-photo">
              <div className="profile-avatar">
                {candidate?.profilePictureUrl ? (
                  <>
                    <img
                      className="img-fluid"
                      src={candidate?.profilePictureUrl}
                      alt={`${candidate?.firstName} ${candidate?.lastName}`}
                    />
                  </>
                ) : (
                  <>
                    <img
                      className="img-fluid"
                      src="assets/images/avatar/avatar2.png"
                      alt="Avatar"
                    />
                  </>
                )}
              </div>
            </div>
            <div className="profile-info">
              <h2 className="heading heading-light">Profile</h2>
              <p className="profile-text">
                Je me nomme {candidate?.firstName} {candidate?.lastName}.
              </p>
              <div
                className="html-content summary-content"
                dangerouslySetInnerHTML={{ __html: candidate?.summary }}
              />
              <div className="contacts">
                <div className="contacts-item">
                  <h3 className="contacts-title">
                    <i className="fas fa-phone-volume"></i> Téléphone
                  </h3>
                  <a
                    href={`tel:${candidate?.phoneNumber1}`}
                    className="contacts-text"
                  >
                    {candidate?.phoneNumber1}
                  </a>
                </div>
                <div className="contacts-item">
                  <h3 className="contacts-title">
                    <i className="fas fa-envelope"></i> Email
                  </h3>
                  <a
                    href={`mailto:${candidate?.email}`}
                    className="contacts-text"
                  >
                    {candidate?.email}
                  </a>
                </div>
              </div>
              <h2 className="heading heading-light">Langues</h2>
              <div className="languages">
                {candidate?.languages.map((language, index) => (
                  <div className="language" key={index}>
                    <span className="language-text">{language?.name}</span>
                  </div>
                ))}
                <div className="lines">
                  <span className="line"></span>
                  <span className="line"></span>
                  <span className="line"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="resume">
            <div className="resume-wrap">
              {/* Your resume content goes here */}
              <div className="logo">
                <div className="logo-lines logo-lines_left">
                  <span className="logo-line"></span>
                  <span className="logo-line"></span>
                  <span className="logo-line"></span>
                </div>
                <div className="logo-img">{initials}</div>
                <div className="logo-lines logo-lines_right">
                  <span className="logo-line"></span>
                  <span className="logo-line"></span>
                  <span className="logo-line"></span>
                </div>
              </div>
              <div className="about">
                <h1 className="name">
                  {candidate?.firstName} {candidate?.lastName}
                </h1>
              </div>
              <div className="experience">
                <h2 className="heading heading_dark">
                  Expérience Professionnelle
                </h2>
                <ul className="list">
                  {candidate?.workExperiences.map((job, index) => (
                    <li className="list-item">
                      <h4 className="list-item__title">
                        {job.title} - {job.companyName}
                      </h4>
                      <span className="list-item__date">
                        {new Date(job.startDate).toLocaleDateString()} -{" "}
                        {new Date(job.endDate).toLocaleDateString()}
                      </span>
                      <p className="list-item__text">{job?.description}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="education">
                <h2 className="heading heading_dark">Parcours Scolaire</h2>
                <ul className="list">
                  {candidate?.educations.map((edu, index) => (
                    <li className="list-item list-item_non-border">
                      <h4 className="list-item__title">{edu.degree}</h4>
                      <span className="list-item__date">
                        {edu.institute}, {edu.startYear} - {edu.endYear}
                      </span>
                      <p className="list-item__text">{edu?.description}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="skills">
                <h2 className="heading heading_dark heading_skills">
                  Compétences
                </h2>
                <ul className="skills-list">
                  {candidate?.skills.map((skill, index) => (
                    <li className="skills-list__item">
                      <div className="skills-list__item-title">
                        {skill.title}
                      </div>
                      <div
                        className="level level-80"
                        style={{
                          width: `${skill.percentage}%`,
                        }}
                      ></div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="button-container">
                <button
                  className="btn btn-print"
                  onClick={() => window.print()}
                >
                  Imprimer mon CV
                </button>
                <button className="btn btn-download" onClick={downloadPDF}>
                  Télécharger le PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

ResumeTemplate5.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, {
  getCandidate,
})(ResumeTemplate5);
